module.exports = __webpack_public_path__ + "img/accessCurated.a4b31c14.png";